import shortid from 'shortid';
export class YTMediaController {
    els;
    constructor(els) {
        this.els = els;
    }
    init() {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        const firstScriptTag = document.getElementsByTagName('script')[0];
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        firstScriptTag?.parentNode.insertBefore(tag, firstScriptTag);
    }
    ready() {
        for (const ytmedia of this.els) {
            new YTMedia(ytmedia);
        }
    }
}
export class YTMedia {
    el;
    media;
    player;
    playerEl;
    playerElID;
    videoId;
    constructor(el) {
        this.el = el;
        this.videoId = this.el.getAttribute('data-yt-id');
        this.media = el.querySelector('.media');
        this.playerEl = document.createElement('div');
        this.playerElID = shortid.generate();
        this.playerEl.id = this.playerElID;
        this.media?.appendChild(this.playerEl);
        this.init();
    }
    init() {
        this.media?.addEventListener('click', () => {
            this.createPlayer();
        });
    }
    createPlayer() {
        this.media?.classList.add('youtube-loaded');
        const image = this.media?.querySelector('img');
        image?.classList.add('opacity-0', 'pointer-events-none', 'h-0');
        if (!this.videoId?.includes('http')) {
            this.player = new window.YT.Player(this.playerElID, {
                videoId: this.videoId,
                events: {
                    onReady: this.onPlayerReady
                },
            });
            this.player.classList.add('aspect-video', 'object-cover', 'w-full', 'h-full');
        }
        else {
            const video = document.createElement('video');
            video.classList.add('aspect-video', 'object-cover', 'w-full');
            video.src = this.videoId;
            video.autoplay = true;
            video.controls = true;
            this.media?.appendChild(video);
        }
    }
    onPlayerReady(e) {
        e.target.playVideo();
    }
}
